import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image = 'https://cdn.filestackcontent.com/J8SmC5PmTHWlMHfi5g4f/convert?cache=true&compress=true&quality=90&format=webp&rotate=exif&w=1200&fit=max',
  url = 'https://nautitours.pt'
}) => {
  const { i18n } = useTranslation();
  
  const siteTitle = 'Nautitours - Passeios de Barco no Rio Guadiana | Vila Real de Santo António';
  const fullTitle = title ? `${title} | Nautitours` : siteTitle;
  
  const defaultDescription = i18n.language === 'pt' 
    ? 'Experiências náuticas inesquecíveis no Rio Guadiana. Passeios de barco, kayak, stand up paddle, motas de água e muito mais em Vila Real de Santo António, Algarve.'
    : i18n.language === 'en'
    ? 'Unforgettable nautical experiences on the Guadiana River. Boat tours, kayak, stand up paddle, jet skis and much more in Vila Real de Santo António, Algarve.'
    : 'Experiencias náuticas inolvidables en el río Guadiana. Paseos en barco, kayak, stand up paddle, motos de agua y mucho más en Vila Real de Santo António, Algarve.';
  
  const metaDescription = description || defaultDescription;
  
  const defaultKeywords = 'nautitours, passeios barco, guadiana, vila real santo antonio, algarve, kayak, stand up paddle, motas água, jet ski, passeio sunset, passeio cultural, tavira, alcoutim, portugal, espanha, turismo algarve, atividades náuticas';
  const metaKeywords = keywords || defaultKeywords;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content="Nautitours" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content={i18n.language} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Nautitours" />
      <meta property="og:locale" content={i18n.language === 'pt' ? 'pt_PT' : i18n.language === 'en' ? 'en_US' : 'es_ES'} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={image} />

      {/* Additional SEO Tags */}
      <meta name="geo.region" content="PT-08" />
      <meta name="geo.placename" content="Vila Real de Santo António" />
      <meta name="geo.position" content="37.1943;-7.4146" />
      <meta name="ICBM" content="37.1943, -7.4146" />
      
      {/* Contact & Business Info */}
      <meta name="contact" content="sales@nautitours.pt" />
      <meta name="phone" content="+351 964 423 117" />
      
      {/* Viewport for mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#1e3a8a" />
    </Helmet>
  );
};

export default SEO;
